var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMblShoe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 134,
    viewBox: "0 0 269 134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.008%",
    x2: "100%",
    y2: "50.008%",
    id: "d3yu8fpuva"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2757E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B8EB",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A398EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "8a0wz6dyob"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FF",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBDED",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.697%",
    y1: "73.626%",
    x2: "-7.422%",
    y2: "-26.623%",
    id: "hcxaaix5wc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FF",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBDED",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.475 18.545-1.86 65.675L1.38 100.405l5.58 18.79 24.56 6.5 78.885 1.86 37 3.91 91.925-4.035 25.66-21.825-.375-15.445-10.13-9-66.68-21.78-3.56-6.045-9-.175-4.95-3.36s-7.97-4.265-8.68-4.41c-.71-.145-7.56-2.17-7.56-2.17l-7.105-4.965-7.165-3.34s-6.325-4-6.42-4.28c-.095-.28-8.555-4.37-8.555-4.37L109.475 15.5s-6.42.28-7.35-.65c-.93-.93-15.905-11.91-15.905-11.91L78.685 4.5l-5.955 5.765-1.5 12.835 3.35 4.84-7.07 2.605-31.625-.745-22.41-11.255z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d3yu8fpuva)",
    fillRule: "nonzero",
    d: "M53.03 72.63 30.665 94.195l70.73 2.43 42.555 8.43-14.885-23.95z",
    transform: "translate(1.38 2.94)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m93 21.855-7.35-7.07C79.465 8.6 88.305 3.03 88.305 3.03M90.71 23.385 70.325 32.66M98.405 27.565l-18.2 10.6M106.1 31.745 90.09 43.67M113.795 35.925 99.97 49.175M121.49 40.105l-11.635 14.58M129.19 44.285l-9.455 15.905M136.885 48.465l-7.27 17.23M144.58 52.645 139.5 71.2M152.275 56.825 149.38 76.71M159.97 61.005l-.705 21.21M167.665 65.185l1.48 22.535M175.36 69.365l3.665 23.86M183.06 73.545l5.85 25.19M190.755 77.725l8.035 26.515",
    stroke: "#D1D3D4",
    strokeWidth: 1.24,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#8a0wz6dyob)",
    fillRule: "nonzero",
    d: "m67.86 28.895-33.42 29 98.015 8.275L68.54 28.24",
    transform: "translate(1.38 2.94)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hcxaaix5wc)",
    d: "m207.59 63.285 45.535 14.935-25.415 21.905-30.3 1.175z",
    transform: "translate(1.38 2.94)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    stroke: "#27AAE1",
    strokeLinejoin: "round",
    strokeWidth: 1.24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m208.97 66.225 45.535 14.935M207.27 72.56l43 12.25M205.575 78.895l40.46 9.57M203.88 85.23l37.915 6.885M202.185 91.57l35.375 4.195M200.485 97.905l32.84 1.51M198.79 104.24l30.3-1.175"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D3D4",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "M12.495 81.12 2.21 98.335l3.625 21.36M20.255 87.345l-7.15 12.51 4.08 23.21M28.255 93.95 24 101.375l3.855 23.94M38.025 97.3l-3.13 5.595 3.405 22.99M48.815 97.855l-3.025 6.56 2.96 22.035M59.885 98.32l-3.2 7.615 2.51 21.08M71.14 98.695l-3.56 8.755 2.06 20.135M82.21 99.625l-3.735 9.345 1.5 17.63M93.835 97.545 89.37 110.49l1.12 15.645M104 99.6l-3.735 12.41.55 13.94M114.17 101.655l-3.01 11.875.26 13.165M124.335 103.705l-2.28 11.345.105 13.875M134.505 105.76l-1.555 10.81-.63 14.415M144.67 107.81l-1.905 23.74M13.045 33.765l28.28 22.28M14.025 25.53 46.62 51.18M20.35 21.485l31.56 24.83M43.79 30.785 57.205 41.45M54.58 30.6l7.915 5.985M44.93 61.6l18.14 14.79M54.985 62.43l15.57 14.81M65.035 63.265l13.005 14.83M75.09 64.095l10.435 14.85M85.14 64.925l7.875 14.87M95.195 65.755l5.305 14.89M105.25 66.59l2.735 14.905M115.3 67.42l.17 14.925M125.355 68.25l-2.4 14.945M135.41 69.08l-4.965 14.965"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m90.71 23.385 14.13-7.49 5.32-.325 16.42 11.925 10.44 4.635 2.4 3.755 7.545 2.37 8.96 5.075 14.44 4.995 4.9 4.835 8.3 1.42 2.23 3.63 4.96 19.515zM13.17 43.275 54.41 75.57l-43.055 7.055z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "M54.41 75.57 32.045 97.135l-19.145-15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m54.41 75.57 76.035 8.475 14.885 23.95-39.63-7.475-73.655-3.385zM69.92 31.18l-34.1 29.655-22.65-17.56-.96-24.62L36.575 30.13zM70.325 32.66l128.465 71.58-8.035-26.515L90.71 23.385z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m69.24 31.835-33.42 29 99.59 8.245zM135.41 69.08l-4.965 14.965L54.41 75.57 35.82 60.835z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m135.41 69.08 26.345 37.94-16.425.975-14.885-23.95z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m135.41 69.08 63.38 35.16-37.035 2.78z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m185.795 58.21 12.995 46.03 10.18-38.015z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m198.79 104.24 30.3-1.175 25.415-21.905-45.535-14.935zM144.67 107.81l-1.905 23.74 8.525-.31 1.455-23.56zM160.175 107.16l-1.135 23.785 8.52-.31.47-24.07zM178.19 105.93l-1.035 25.015 8.525-.31.37-25.3zM195.465 104.51l-.79 24.79 8.52-.31.075-24.805zM214.03 103.945l.55 24.33 8.97-.36-1.625-24.285z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m229.28 102.865 4.485 25.475 9.505-4.935-7.265-26.28zM242.495 91.535l9.835 25.685 10.76-8.345-15.065-22.005z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    fill: "#72F596",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "m129.13 27.705-19.055 18.73 8.775 5.295 18.43-19.115zM145.225 37.165l-19.05 18.73 9.51 5.57L154.12 42.35zM161.63 45.39 142.5 64.9l9.515 5.575 18.51-19.9zM178.525 53.12l-18.56 20.77 9.515 5.57 18.365-22.41z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    strokeWidth: 2.835,
    strokeLinejoin: "round",
    d: "m12.125 17.195.715 27.69-.345 36.235L2.21 98.335l3.625 21.36 26.115 7.49 72.775-1.445 36.865 6.03 97.76-4.33 26.91-20.595-.455-15.925-11.3-9.76-66.68-21.78-1.065-3.675-8.77-3.315-2.725.77-3.385-1.89-1.515-2.945-9.09-3.86-3.43.9-3.775-2.145-.72-2.605-9.195-4.1-2.495.845-4.47-3.18-.17-2.05-8.105-4.73-2.335.095-16.42-11.925-6.665-.515L88.305 3.03l-8.255.735-8.955 5.64-.58 11.73L76.3 27.71l-6.38 3.47-33.345-1.05z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.24,
    strokeLinejoin: "round",
    d: "m254.505 81.16-25.415 21.905-83.76 4.93-39.63-7.475-73.655-3.385-19.55-16.015L2.21 98.335l3.175 20.11 26.565 8.74 72.775-1.445 36.865 6.03 97.76-4.33 26.91-20.595-.455-15.925z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m117.99 93.2-.06-8.53-5.335-4.5 3-2.595-.055-7.675-6.855-5.705-6.175.045-.04-6-6.915.05.04 6H91.66l-.045-6-6.915.045.045 6-9.875.07.25 35.335 9.875-.07.06 8.5 6.915-.045-.06-8.5 3.935-.03.065 8.5 6.91-.05-.06-8.5 7.895-.055 7.335-6.29zm-12.71-19.445v2.5l-1.905 1.58-18.12.125-.045-5.65 18.12-.13 1.95 1.575zm-.175 17.82-19.735.14-.045-6.31 19.735-.14 2.59 2.1v2.07l-2.545 2.14z",
    stroke: "#231F20",
    strokeWidth: 1.24,
    fill: "#72F596",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMblShoe);
export default __webpack_public_path__ + "static/media/mbl-shoe.9fa8ed82cf2bb246eb6669d3bda3ac89.svg";
export { ForwardRef as ReactComponent };